import { useNavigate } from 'react-router-dom';
import { useTrackCTA } from '../CtaClick/TrackCtaClick';

export const useBecomeAMemberHandler = () => {
  const trackCTA = useTrackCTA();
  const navigate = useNavigate();

  const onClickBecomeAMember = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    trackCTA({
      cta_position: 'content',
      text: 'Bli medlem',
      url: '/medlemskap',
    });
    navigate('/medlemskap');
  };

  return onClickBecomeAMember;
};
